// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__2qGFb","anchor":"Item_anchor__3Y-K4","title":"Item_title__2JXLR"};